import { apiGetPersonSettings } from "api/personApi";
import { ContainedTabsProps } from "components/Tabs/Tabs3";
import { useEffect, useState } from "react";


import avatar from "assets/images/AvatarIcon.svg";
import productImage from "assets/images/product-bg.png";
import projectAccounting from "assets/reports/projectAccounting.svg";
import branchAccounting from "assets/reports/branchAccounting.svg";
import BasicButton from "components/BasicInputs/BasicButton";
import PlusIcon from "assets/icons/PlusIcon";
import { apiGetProjects } from "api/projectApi";
import { apiGetBranches } from "api/branchApi";
import Select from "components/Table2/CellComps/Select";
import Price from "components/Table2/CellComps/Price";
import { apiGetPricePlans, apiProductsList } from "api/productApi";
import shortid from "shortid";
import CondInput, { CondInputProps } from "components/Table2/CellComps/CondInput";
import useCurrency from "helpers/useCurrency";
import { apiGetFactor, apiGetFactorTransaction } from "api/factorApi";
import { DateToString } from "components/Reports/DateFilter";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { appSetAlert, appSetLoading, appSetModal, setConfirm } from "store/actions/appAction";
import PercentIcon from "assets/icons/PercentIcon";
import { resetFactor, setFactor as setFactorRedux } from "store/actions/factorAction";
import normalizeFactorData from "./normalize/normalizeFactorData";
import normalizeFactorItems from "./normalize/normalizeFactorItems";
import usePrevious from "helpers/usePrevious";
import Text from "components/Table2/CellComps/Text";
import axios from "../../axios/axios";
import { errorDispatcher, setSelectItemLabels } from "helpers";
import productsSelectBoxLayout from "./layouts/productsSelectBoxLayout";
import useResponsive from "helpers/useResponsive";
import generateUnitConds from "./normalize/generateUnitConds";
import useDidUpdateEffect from "helpers/useDidUpdateEffect";
import MobileRow from "./layouts/MobileRow";
import MultiSelect, { MultiSelectRow } from "./comps/MultiSelect";
import { useAppDispatch, useAppSelector } from "store/store";
import { apiGetWarehouses, apiGetWarHousesByProductId } from "api/warehouseApi";
import getCurrency from "helpers/currencyHelper";
import HashtagIcon from "assets/icons/Hashtag";
import { apiDeleteTransactions } from "../../api/transactionApi";
import { sendToPos } from "helpers/helper";
import { apiSetAlert } from "api/appApi";
import useKeyboardShortcuts from "helpers/useKeyboardShortcuts";

/* ----------------------------- Initializations ---------------------------- */
// Initial Price plans
const defaultPricePlans: Plan[] = [
  { title: "قیمت فروش", key: "sellPrice", ind: shortid.generate(), code: "" },
  { title: "قیمت خرید", key: "buyPrice", ind: shortid.generate(), code: "" }
];

// Initial Costs
const defaultCosts: Cost[] = [
  { title: "مالیات", name: "taxInput", key: "tax", active: false, value: 0, type: "percent" },
  { title: "تخفیف", name: "discountInput", key: "discount", active: false, value: 0, type: "percent" },
  { title: "حمل و نقل", key: "transport", active: false, value: 0, type: "currency", allowedCond: [1] }
];

// Tabs show input and table
const inputsOnTabs: { [key: number]: string[] } = {
  0: ["buyer", "dates", "title", "aCode", "taxType", "taxSettlementType", "pb", "reference", "sell", "dsc2"],
  1: ["seller", "dates", "title", "aCode", "pb", "reference", "dsc2"],
  2: ["title", "date", "dsc", "aCode", "pb", "reference"]
};

// tabs Types
const typesOnTabs: { [key: number]: string } = { 0: "sale", 1: "buy", 2: "waste" };

// pure functions
const renderWarehouse = (option: any) => {
  return (
    <div className="flex items-center w-full gap-4">
      {option.image && (
        <div
          className={`rounded-full overflow-hidden border border-slate-200 bg-center bg-cover bg-no-repeat`}
          // onClick={() => }
          style={{
            backgroundImage: `url("${option.image}")`,
            minHeight: 24,
            minWidth: 24
          }}
        />
      )}
      <div className="flex flex-col justify-center w-full gap-1 overflow-hidden">
        {option.ind && option.title ? (
          <div className="flex items-center gap-1 text-xs md:text-sm">
            <span className="text-dark-6">{option.ind}</span>
            <div className="flex items-center gap-1">
              <span className="flex items-center justify-center w-4 h-4 rounded bg-slate-100">
                <HashtagIcon color="#7E8C9E" style={{ transform: "scale(0.8)" }} />
              </span>
              <span>{" - "}</span>
            </div>
            <span className="overflow-hidden text-ellipsis text-dark-6">{option.title}</span>
            <div className={`flex-grow text-end ${option?.quantity < 1 ? "text-red-600" : "text-zinc-500"} `}>
              <span>موجودی:</span>
              <span className={`pr-1 overflow-hidden text-ellipsis`}>
                {option?.quantity}
              </span>
            </div>
          </div>
        ) : (
          <span className="overflow-hidden text-ellipsis">{option.label}</span>
        )}
        <span className="text-sm text-slate-400">{option.dsc}</span>
        {option.footer}
      </div>
    </div>
  );
};

/* ------------------------------ Main Function ----------------------------- */
export default function useFactor() {
  /* ---------------------------------- Hooks --------------------------------- */
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { id, type } = useParams();
  const { change, currencies, defCur } = useCurrency();
  const { isMobile } = useResponsive();

  /* ---------------------------------- Store --------------------------------- */
  const store = useAppSelector((state) => state);
  const token = store?.businessReducer?.business?.token;
  // const persons: Person[] = store?.personReducer?.allPerson || [];
  const projects: Project[] = store?.projectReducer?.projects || [];
  const branches: Branch[] = store?.branchReducer?.branches || [];

  useKeyboardShortcuts([], (value) => {
    if (value.key === 'insert') {
      handleAddRow()
    }
  });
  const warehouses: Warehouse[] = store?.warehouseReducer?.warehouses || [];
  // const products: Product[] = store?.productReducer?.allProducts || [];
  const [persons, setPersons] = useState<Person[]>([])
  // const [products, setProduct] = useState<Product[]>([])
  const productPrices: Price[] = store?.productReducer?.prices || [];
  const app: any = store.appReducer;
  const { DefaultSelectedPerson, DefaultCustomer, DuplicateRowsInFactor, DisableTax, shouldUpdateBillAfterEditFactor, factorCreateSMS, ForceActiveTransAction } =
    app.appSettings;
  // Price Plans
  const plans: Plan[] = store?.productReducer?.pricePlans || [];
  const p = [...defaultPricePlans, ...plans];
  const pricePlans = p.map((x) => ({ label: x.title, value: x.id || x.key || x.title }));
  /* ---------------------------------- State --------------------------------- */
  // const [personInfo, setPersonInfo] = useState({ selectBuyer: 0, selectSeller: 0, selectSell: 0 });
  const [active, setActive] = useState({ tab: 0, returned: false, saving: false, summaryTab: 0 });
  const [saved, setSaved] = useState({ factor: false, transaction: false, remittance: false });
  const [noChange, setNoChange] = useState(false);
  // const [count, setCount] = useState(0)
  const [rows, setRows] = useState<FactorProductRow[]>(addInitialRows());
  const [factor, setFactor] = useState({ id: id ? +id : undefined, type });
  const [conds, setConds] = useState<{ unit: Cond[]; tax: Cond[] }>({
    unit: [
      {
        title: "عدد",
        label: <span className="font-bold">{"عدد"}</span>,
        value: "single",
        type: "number-native"
      }
    ],
    tax: [
      {
        title: "percent",
        label: <PercentIcon style={{ transform: "scale(0.7)" }} />,
        value: "percent",
        type: "number-native",
        min: 0,
        max: 100
      },
      {
        title: "currency",
        label: <span className="font-bold">{defCur.en_title}</span>,
        value: "currency",
        type: "price"
      }
    ]
  });
  const [warehouseStock, setWarehouseStock] = useState<any[]>(warehouses.map(row => {
    return {
      ...row,
      id: row.id,
      label: row.title,
      value: row.id,
      ind: row.id,
      image: projectAccounting,
      title: row.title,
      dsc: row.title,
    }
  }));

  const initialState: FactorState = {
    currency: currencies[0],
    pricePlan: pricePlans[0],
    notification: factorCreateSMS,
    updateBill: shouldUpdateBillAfterEditFactor,
    curRow: undefined,
    costs: defaultCosts,
    settings: {
      transaction: { active: false, title: "ثبت تراکنش", key: "transaction" },
      warehouse: { active: false, title: "ثبت حواله انبار", key: "warehouse" }
    },
    transactions: ForceActiveTransAction ? [{ data: { price: 0 }, ind: shortid.generate(), edit: true, done: false }] : [],
    canPay: ForceActiveTransAction === true,
    notes: [],
    transactionsBelong: [],
    pagination: { page: 1, perPage: 5 }
  };
  const [state, setState] = useState<FactorState>(initialState);
  const prevState: FactorState = usePrevious(state);

  const initialData: FactorMainData = {
    currencyExchange: state.currency.currencyExchange || 1,
    currencyId: state.currency.id,
    date: DateToString(Date.now()),
    dueDate: DateToString(Date.now()),
    factorType: typesOnTabs[active.tab],
    status: "تایید شده"
  };
  const [data, setData] = useState<FactorMainData>(initialData);
  /* -------------------------------- Variables -------------------------------- */
  // Current Models
  const person = persons?.find((x) => x.id === data?.PersonId);
  const seller = persons?.find((x) => x.id === data?.SellerId);
  const project = projects?.find((x) => x.id === data?.ProjectId);
  const branch = branches?.find((x) => x.id === data?.BranchId);
  // Conditions
  const isCopy = searchParams.get("copy");
  const isEdit = !!factor.id && !!factor.type && !isCopy;
  const unitConditions = conds.unit;
  const taxConditions = getTaxCond();

  // Total Costs
  const tTax = state.costs[0];
  const tDiscount = state.costs[1];
  const totalTaxType = tTax.type;
  const totalDiscountType = tDiscount.type;
  const totalDiscountCond = taxConditions.find((x) => x.value === totalDiscountType);
  const totalTaxCond = taxConditions.find((x) => x.value === totalTaxType);

  // Prices
  let prices = {
    tablePrice: 0,
    totalDiscountPrice: 0,
    totalPrice: 0,
    totalTaxPrice: 0,
    extraCosts: 0,
    transactionsPrice: 0,
    payablePrice: 0,
    profitPrice: 0
  };
  if (rows.length > 0) {
    const tablePrice = rows.map((x) => (x.price || 0) * (x.count || 0)).reduce((a, b) => a + b);
    const payablePrice = rows
      .map((x) => {
        const dscnt = getCostPrice(x.discountInput, x.price || 0);
        return ((x.price || 0) - (dscnt || 0)) * (x.count || 0);
      })
      .reduce((a, b) => a + b);

    const totalPrice = rows.map((x) => x.totalPrice || 0).reduce((a, b) => a + b);
    const totalBuyPrice = rows.map((x) => (x.product?.buyPrice || 0) * (x.count || 0)).reduce((a, b) => a + b);

    const totalTaxPrice = rows
      .map((x) => {
        const dscnt = getCostPrice(x.discountInput, x.price || 0);
        return getCostPrice(x.taxInput, ((x.price || 0) - (dscnt || 0)) * (x.count || 0) || 0);
      })
      .reduce((a, b) => a + b);

    const totalDiscountPrice = rows
      .map((x) => {
        return getCostPrice(x.discountInput, (x.price || 0) * (x.count || 0)) || 0
      })
      .reduce((a, b) => a + b);

    const profitPrice = tablePrice - totalDiscountPrice - totalBuyPrice;

    const extraCosts = state.costs
      .flatMap((x, i) => {
        if ([0, 1].includes(i)) return [];
        return getCostPrice(
          {
            val: x.value,
            cond: taxConditions.find((y) => y.value === x.type)
          },
          tablePrice
        );
      })
      .reduce((a, b) => a + b);
    const transactionsPrice =
      state.transactions.length > 0
        ? state.transactions.map((x) => x.data?.price || 0).reduce((a, b) => a + b)
        : 0;
    prices = {
      tablePrice,
      totalDiscountPrice,
      totalPrice: totalPrice + extraCosts,
      totalTaxPrice,
      extraCosts,
      transactionsPrice,
      payablePrice,
      profitPrice
    };
  }

  /* --------------------------------- Effects -------------------------------- */

  useEffect(() => {
    // if (!persons?.length) dispatch(apiPersonsList(token, "allPerson", (res: Person[]) => {
    //   setPersons(res)
    // }));
    if (!warehouseStock?.length) dispatch(apiGetWarehouses(token));
  }, []);
  useEffect(() => {
    if (!id && !type) {
      setWarehouseStock(warehouses.map(row => {
        return {
          ...row,
          id: row.id,
          label: row.title,
          value: row.id,
          ind: row.id,
          image: projectAccounting,
          title: row.title,
          dsc: row.title,
        }
      }))
      const defaultWarehouse = warehouses?.find((x) => x.default === true);
      setData(state => { return { ...state, WarehouseId: isEdit ? 0 : defaultWarehouse?.id } })
      setState(state => {
        return {
          ...state,
          settings: { ...state.settings, warehouse: { ...state.settings.warehouse, active: defaultWarehouse !== undefined, } },
        }
      })

    }

  }, [warehouses])


  useEffect(() => {
    if (!plans.length) {
      dispatch(apiGetPricePlans(token))
    }
    // dispatch(apiProductsList({ type: typesOnTabs[active.tab], token, cb: (res: any) => setProduct(res) }))
    if (active.tab) {
      if (active.tab) {
        const option = {
          label: "قیمت خرید",
          value: "buyPrice"
        };
        setState((x: any) => ({ ...x, pricePlan: option }));
      }
    } else {
      const option = {
        label: "قیمت فروش",
        value: "sellPrice"
      };
      setState((x: any) => ({ ...x, pricePlan: option }));
    }
    return () => {
    };
  }, [active]);

  // Change data on edit
  useEffect(() => {
    if (id && type) {
      dispatch(
        apiGetFactor(id, type, token, async (f: Factor) => {
          dispatch(setFactorRedux(f));
          let Active = { ...active };
          let type = f.type;
          if (type.includes("Return")) {
            Active.returned = true;
            type = type.replace("Return", "");
          }
          let tab = Object.keys(typesOnTabs).find((x: any) => typesOnTabs[x] === type) || "0";

          setActive({ ...Active, tab: +tab });
          setFactor({ id: f.id, type: f.type });
          setData((x) => ({ ...x, ...normalizeFactorData(f) }));
          setRows(normalizeFactorItems(f));
          const t = await apiGetFactorTransaction(f.id, token, dispatch);
          if (t?.transactions.length > 0) {

            setState((x) => ({
              ...x,
              transactionsBelong: t.transactions.map((transaction: any) => transaction.transactionBelong)
            }));
          }
          const currency = currencies.find((x) => x.id === f.CurrencyId);
          const hasWarehouse = !!f?.Factor_Items?.find((x: any) => x.warehouseId);
          setState((x) => {
            return {
              ...x,
              ...(currency && { currency }),
              costs: x.costs.map((x, i) => {
                switch (i) {
                  case 0:
                    return { ...x, value: Math.ceil((f.totalTax * 100) / (f.totalPrice - (f?.transferPrice || 0))) || 0, active: !!f.totalTax, type: "percent" };
                  case 1:
                    return {
                      ...x,
                      value: f.totalDiscount || 0,
                      active: !!f.totalDiscount,
                      type: "currency",
                    };
                  case 2:
                    return { ...x, value: f.transferPrice || 0, active: !!f.transferPrice };
                  default:
                    return x;
                }
              }),
              settings: { ...x.settings, warehouse: { ...x.settings.warehouse, active: hasWarehouse } },
              hasWarehouse,
              transaction: t
            }
          });
          setNoChange(true);
          reRender();
        })
      );
    }
  }, [id, type]);

  useDidUpdateEffect(() => {
    if (!id && !type) {
      resetForm();
    }
  }, [token, id, type]);

  // Change prices at price plan change
  useEffect(() => {
    if (!noChange && !id) {
      const newRows = rows.map((x) => {
        if (x.price === undefined) return x;
        let price = x.price;
        if (prevState.pricePlan.value !== state.pricePlan.value) {
          price = getPrice(x.product);
        }
        if (prevState.currency.id !== state.currency.id) {
          price = change(prevState.currency.en_title, state.currency.en_title, price);
        }
        let nr: FactorProductRow = { ...x, price, constantPrice: price };
        nr = { ...nr, totalPrice: getTotalPrice(nr) };
        return nr;
      });
      setRows(newRows);
      reRender();
    } else {
      setNoChange(false);
    }
  }, [state.currency, state.pricePlan]);
  useEffect(() => {
    getInventoryProductCount(0, true)

    return () => {

    }
  }, [])

  // useEffect(() => {
  //   dispatch(
  //     //@ts-ignore
  //     apiWarehouseStock({
  //       token,
  //       options: undefined,
  //       params: undefined,
  //       getSupply: (data: any) => {
  //         //@ts-ignore
  //         const map = data.reduce((a, v) => ({ ...a, [v.productId]: v }), {});
  //         setWarehouseStock(map);
  //       }
  //     })
  //   );
  // }, []);

  /* -------------------------------- Functions ------------------------------- */

  function reRender() {
    // setCount((x) => x + 1);
  }

  function addInitialRows() {
    if (isMobile) return [];
    const array: FactorProductRow[] = [];
    for (let index = 0; index < 5; index++) {
      const id = shortid.generate() + index
      array.push({ id });
    }
    return array;
  }

  function handleAddRow() {
    return new Promise<{ id: string; rows: FactorProductRow[] }>((resolve) => {
      const id = shortid.generate() + rows.length + 1;

      const newRows = [...rows, { id }];
      setRows(newRows);
      reRender();
      resolve({ id, rows: newRows });
    });
  }
  const doAfterSubmit = (args: { isSuccess: boolean, callBack?: () => void, mode?: "printMode" | 'newMode' | "editMode", factor: any }) => {
    const { callBack, factor, mode, isSuccess } = args
    if (isSuccess) {
      dispatch(appSetAlert("عملیات ثبت فاکتور با موفقیت انجام شد تراکش در سیستم ثبت گردید", "success"));
      if (callBack) return callBack();
      setActive((x) => ({ ...x, saving: true }));
      setSaved((x) => ({ ...x, transaction: true }));
      if (mode === "printMode") {
        navigateTo(1, factor)
      } else if (mode === "newMode") {
        resetForm();
        window.scrollTo(0, 0);

      }

    }
  }
  const sendPosAfterTrans = async (args: { posInfo: any[], transInfo: any[], callBack: (res: boolean, ignore: boolean) => void }) => {
    const { posInfo, transInfo, callBack } = args
    const posRes = []
    if (posInfo.length && transInfo) {

      for (let index = 0; index < posInfo.length; index++) {
        const element = posInfo[index];
        const transId = transInfo.find((x: any) => x.index === element.index)
        const res = await sendToPos({ amount: element.amount, posIp: element?.typeOption.ip, posPort: element.typeOption.port, transId: transId })
        posRes.push({ ...res?.data, ...element, ...transId })
      }
    }
    const failPoss = posRes.filter(x => x.result === false)
    if (failPoss.length) {
      failPoss.map(x => {
        dispatch(setConfirm("اخطار", async () => {
          await sendPosAfterTrans({ posInfo, transInfo, callBack })
        }, undefined, `تراکنش با مبلغ ${x.amount} برای دستگاه کارتخوان ناموفق بوده است ایا تراکنش را تکرار میکنین؟ `, () => {
          callBack(false, true)
        }));

      })
    }
    callBack(failPoss.length === 0, false)
    return true
  }
  async function handleSubmit(num: number, callBack?: () => void, mode?: "newMode" | "printMode" | "editMode") {
    // if (prices.transactionsPrice) {
    // if (prices.totalPrice !== prices.transactionsPrice) {
    //   dispatch(appSetAlert("مجموع مبالغ  فاکتور و تراکنش باید برابر باشد", "error"));
    //   return;
    // }
    // if (!state.transactions.find((x) => x.type && (x.data as any)[x.type])) {
    // dispatch(appSetAlert("لطفا تراکنش را تکمیل کنید", "error"));
    // return;
    // }
    // }
    let Factor = factor;
    const st: { [key: number]: FactorMainData["status"] } = { 1: "تایید شده", 2: "پیش نویس", 3: data.status };
    const status = st[num];
    const isPending = status === "پیش نویس";
    const tTypes: any = { sale: "receive", buy: "payment" };
    const fType = typesOnTabs[active.tab];
    let factorFD = {
      main: {
        accountingCode: data.accountingCode,
        title: data.title,
        pricePlanId: ["sellPrice", "buyPrice"].includes(state.pricePlan.value.toString()) ? null : state.pricePlan.value,
        description: data.description,
        taxType: data.taxType,
        note: data.note,
        reference: data.reference,
        status: status,
        date: data.date,
        taxSettlementType: data.taxSettlementType,
        dueDate: data.dueDate,
        transferPrice: state.costs[2].value || undefined,
        PersonId: data.PersonId,
        ProjectId: data.ProjectId,
        BranchId: data.BranchId,
        SellerId: data.SellerId,
        sellerCommission: data.sellerCommission?.toString() ? parseFloat(data.sellerCommission?.toString()) : 0,
        commissionType: data.commissionType === "percent" ? "percent" : "number",
        WarehouseId: data.WarehouseId,
        factorType: `${typesOnTabs[active.tab]}${active.returned && typesOnTabs[active.tab] !== "waste" ? "Return" : ""
          }`,
        currencyId: state.currency.id,
        currencyExchange: state.currency.currencyExchange || 1,
        shouldSendSms: state.notification,
        shouldUpdateBill: isEdit ? state.updateBill : !!rows.find((x) => x.warehouseId),
        notes: state.notes
      },
      products: rows
        .filter((x) => !!x.productId)
        .map((x) => {
          const discount = getCostPrice(x.discountInput, x.price);
          const tax = getCostPrice(x.taxInput, (x.price || 0) - discount);
          return {
            productId: x.productId,
            unit: x.unit,
            quantity: x.quantity,
            price: x.price,
            description: x.description,
            warehouseId: x.warehouseId,
            tax: tax * (x.quantity ?? 1),
            discount: discount * (x.quantity ?? 1)
          };
        })
    };
    // return
    const posInfo: any[] = []
    let transactionFD = {
      transaction: {
        accountingCode: data.accountingCode,
        date: data.date,
        description: data.description,
        factorId: Factor.id,
        ProjectId: data.ProjectId,
        transactionType: tTypes[fType],
        BranchId: data.BranchId
      },
      secondItems: state.transactions.flatMap((x, ix) => {
        if (!x.type || !x.data) return [];
        const isPos = x.type === "pos"
        const rrr = { ...x, index: ix }
        const optionableType = ["bank", "cashier", "fund", "pos"].includes(x.type) ? "financial" : x.type;
        const optionableId: number = isPos ? x.data.typeOption.FinancialId : (x.data as any)[x.type];

        const allItemInfo = {
          amount: x.data?.price,
          wage: x.data?.wage,
          optionableId,
          optionableType,
          chequeDate: x.data.date,
          chequeIssuingBank: x.data.issuingBank,
          chequeBranch: x.data.branch,
          chequeNumber: x.data.number,
          sayad: x.data.sayad,
          status: isPos ? "posPending" : null,
          index: ix,
        };
        if (isPos) {
          posInfo.push({ ...rrr, ...allItemInfo, typeOption: x.data.typeOption })
        }
        return allItemInfo
      })
    };
    let factorUrl = "factors";
    let transactionUrl = "transactions/factor/transaction";
    let remittanceUrl = "bills";
    let req = axios.post;
    const conf = { headers: { Authorization: `Bearer ${token}` } };
    if (isEdit) {
      factorUrl = `factors/${id}`;
      req = axios.put;
    }
    setActive((x) => ({ ...x, saving: true }));
    req(factorUrl, factorFD, conf)
      .then(async (factorResponse) => {
        let factor: Factor = factorResponse.data.factor;
        if (factor) {
          transactionFD.transaction.factorId = factor.id;
          transactionFD.transaction.description = `سند ${factor.type === "sale" ? "دریافت" : "پرداخت"
            } فاکتور شماره ${factor.accountingCode}`;
        }

        dispatch(setFactorRedux(factor));
        await new Promise((resolve) => setTimeout(resolve, 1000));
        setSaved((x) => ({ ...x, factor: true }));
        setSaved((x) => ({ ...x, remittance: true }));
        for (const note of state.notes) {
          if (note.deletedAt && note.id) {
            await axios.delete(`notes/${note.id}`, conf);
          }
          if (!note.id && !note.deletedAt) {
            const newNote = { detail_id: factor?.id || Factor?.id, detail_type: "Factor", text: note.text };
            await axios.post("notes", newNote, conf).catch();
          }
        }
        if (isPending || !transactionFD.secondItems?.length) {
          if (isEdit && state.transaction?.transaction && state.transactions.length === 0) {
            dispatch(apiDeleteTransactions([state.transaction.transaction.id], token, { key: state.transaction.transaction.type }));
          }
          dispatch(appSetAlert(factorResponse.data.message, "success"));
          doAfterSubmit({ callBack, factor: factor || Factor, isSuccess: true, mode, })

        }
        if (state.canPay) {
          if (state.transaction?.transaction) {
            transactionUrl = `transactions/${state.transaction.transaction.id}`;
            await axios.put(transactionUrl, transactionFD, conf).catch(() => {
            });
          } else {
            return axios.post(transactionUrl, transactionFD, conf).catch(() => { }).then(async (result) => {

              if (posInfo.length) {
                const transInfo = result?.data.transactionItems
                const res = await sendPosAfterTrans({
                  posInfo, transInfo, callBack: (res, ignore) => {
                    doAfterSubmit({ callBack, factor: factor || Factor, isSuccess: res ? res : ignore, mode, })

                  }
                })
              } else {
                doAfterSubmit({ callBack, factor: factor || Factor, isSuccess: true, mode, })
              }

            })
          }

        }
        doAfterSubmit({ callBack, factor: factor || Factor, isSuccess: true, mode, })
      }).catch((err) => {
        setActive((x) => ({ ...x, saving: false }));
        errorDispatcher(err, dispatch);
      });
  }

  function resetForm() {
    dispatch(resetFactor());
    setFactor({ id: undefined, type: undefined });
    setData({ ...initialData, WarehouseId: data.WarehouseId, PersonId: data.PersonId, title: data.title });
    setRows(addInitialRows());
    setState((x) => ({ ...x, currency: defCur, transactions: [], costs: x.costs.map((y) => ({ ...y, value: 0 })) }));
    setNoChange(true);
    setSaved({ factor: false, remittance: false, transaction: false });
    setActive((x) => ({ ...x, returned: false, saving: false, tab: 0 }));

    reRender();
  }

  function navigateTo(num: number, factor: any) {
    const params = `factorId=${factor.id}&factorType=${factor.type}`;
    const nv: { [key: number]: string } = {
      0: `/transactions/add?displayHeader=0&${params}`,
      1: `/factors/view?${params}`
    };
    navigate(nv[num]);
  }

  function handleBarcodeScan(barcode: string) {
    // @ts-ignore
    // const product = products.find((x) => x.barcodes.includes(`${barcode}`));
    // if (product) {
    //   const rowWithoutProduct = rows.find(x => !x.productId)
    //   const row = rows.find((x) => x.productId === product.id);
    //   if (row && !DuplicateRowsInFactor) {
    //     row.count = row.quantity !== undefined ? row.quantity + 1 : 1
    //     addProduct(product, row);
    //   } else if (rowWithoutProduct) {
    //     addProduct(product, rowWithoutProduct);
    //   } else {
    //     handleAddRow().then(({ id, rows }) => {
    //       addProduct(product, { id }, rows);
    //     });
    //   }
    // }
    if (beforeLoadingPerSelectBox) {
      let params = beforeLoadingPerSelectBox({ name: "selectProDuct", status: "beforeSendRequest", params: { limit: 1, page: 1 } })
      if (barcode && barcode !== "") {
        params["primarySearch"] = barcode
        params["searchColumns"] = "barcode"
      }
      axios.get('/products/list/active', {
        headers: { Authorization: `Bearer ${token}` },
        params
      }).then((res: any) => {

        const data = beforeLoadingPerSelectBox({ name: "selectProDuct", status: "afterSendRequest", params: res.data })
        if (data.length === 0) {
          return dispatch(apiSetAlert("بارکد مورد نظر یافت نشد", "warning", true))
        }

        const product = data[0]
        const rowWithoutProduct = rows.find(x => !x.productId)
        const row = rows.find((x) => x.productId === product.id);
        if (row && !DuplicateRowsInFactor) {
          row.count = row.quantity !== undefined ? row.quantity + 1 : 1
          addProduct(product, row);
        } else if (rowWithoutProduct) {
          addProduct(product, rowWithoutProduct);
        } else {
          handleAddRow().then(({ id, rows }) => {
            addProduct(product, { id }, rows);
          });
        }



      })
    }
  }
  const getCosts = async () => {
    let costs: Cost[] = []
    setState(state => {
      costs = state.costs
      return state
    })
    await new Promise((resolve) => setTimeout(resolve, 100));
    return costs

  }
  async function addProduct(product: Product, row: FactorProductRow, r?: FactorProductRow[]) {
    let Rows = r || rows;
    const index = Rows.findIndex((x) => x.id === row.id);
    const cost = await getCosts()
    const tax = cost[0]
    const disCount = cost[1]
    const totalTaxType = tax.type;
    const totalDiscountType = disCount.type;
    const taxCond = taxConditions.find((x) => x.value === totalTaxType);
    const disCountCond = taxConditions.find((x) => x.value === totalDiscountType);
    if (index < 0) return false;
    const same = Rows.findIndex((x) => {
      return x.id === row.id && x.productId === product.id;
    });

    if (same >= 0 && !DuplicateRowsInFactor) {
      const s = Rows[same];
      const quantity = row.count ? row.count : row.quantity ? row.quantity : 1
      const unit = s.unit;
      const i = s?.unitConds?.findIndex((x: any) => x.title === unit);
      let count = quantity;
      const rate = s.conversionRatio || 1;
      let price = s?.constantPrice;
      if (i === 1) {
        price = (price || 0) * rate;
      }
      let nr = {
        ...row,
        description: row.description ? row.description : "",
        //warehouseId: row.warehouseId ? row.warehouseId : data.WarehouseId ? data.WarehouseId : 0,
        ...s, quantity, count, price, constantPrice: s?.constantPrice,
        //discountInput: { val: row.discount ? row.discount : disCount.value, cond: disCountCond },
        // taxInput: { val: tax.value, cond: taxCond }
      };
      nr = { ...nr, totalPrice: getTotalPrice(nr) };
      Rows[same] = nr;
      setRows([...Rows]);
      reRender();
      if ((product.id !== row.productId)) {
        await getInventoryProductCount(product.id, false, product.type === "خدمات")

      }
      return true
    }
    // Price
    const price = row.price && isEdit && row.productId === product.id ? row.price : getPrice(product);
    // const discountInput = { val: 0, cond: totalDiscountCond };
    const defTax = active.tab === 0 ? product.saleTax : active.tab === 1 ? product.buyTax : undefined;
    // const taxInput = { val: tTax.value, cond: totalTaxCond };
    const discountInput = row.discountInput ? row.discountInput : { val: disCount.value, cond: disCountCond }
    const taxInput = row.taxInput ? row.taxInput : { val: tax.value, cond: taxCond }
    const unitConds = generateUnitConds({ val: product });
    const count = row.count || 1;
    let nr: FactorProductRow = {
      ...Rows[index],
      product: product,
      description: Rows[index].description ? Rows[index].description : "",
      productId: product.id,
      price,
      constantPrice: price,
      count,
      quantity: count,
      conversionRatio: product.conversionRatio,
      discountInput,
      taxInput,
      unit: row.unit || product.unit,
      unitConds,
      warehouseId: product.type === "کالا" ? row.warehouseId ? row.warehouseId : data.WarehouseId || undefined : undefined
    };
    nr = { ...nr, totalPrice: getTotalPrice(nr) };

    rows[index] = nr;
    setState(x => { return { ...x, curRow: rows[index] } })
    let newRows = [...Rows];

    defTax &&
      setState((x) => ({ ...x, costs: x.costs.map((y, j) => (j === 0 ? { ...y, active: true } : y)), }));
    // if (tDis.active && tDis.type === "currency" && tDis.value) {
    //   newRows = spreadCost(newRows, tDis);
    // }
    // if (tTax.active && tTax.type === "currency" && tTax.value) {
    //   newRows = spreadCost(newRows, tTax);
    // }
    setRows(newRows);
    reRender();
    if ((product.id !== row.productId)) {
      await getInventoryProductCount(product.id, false, product.type === "خدمات")
    }

    return true
  }
  const getInventoryProductCount = async (productId: string | number, isFromInventory?: boolean, isService?: boolean) => {
    if (isService) return
    if (productId) dispatch(appSetLoading(true))
    dispatch(apiGetWarHousesByProductId({
      callback: async (res: any) => {
        let totalCount = 0
        const inventory = res.map((row: any) => {
          totalCount += row.quantity
          return {
            ...row,
            id: row.warehouseId,
            label: row.title,
            value: row.warehouseId,
            ind: row.accountingCode,
            image: projectAccounting,
            title: row.title,
            dsc: row.title,
            // supply: warehouseSupplies[x.id],
            render: renderWarehouse
          }
        })

        // await new Promise((resolve) => setTimeout(resolve, 300));
        const newRows = rows
        for (const ix in newRows) {
          const row = { ...newRows[ix] }
          if (row.productId === productId) {
            newRows[ix] = { ...row, totalCount }
          }
        }
        let xxx = [...newRows]
        if (isFromInventory)
          setWarehouseStock(inventory)

        // await new Promise((resolve) => setTimeout(resolve, 300));
        setRows(xxx)
        if (productId) dispatch(appSetLoading(false))
      }, productId: productId
    }))
  }
  function clearProduct(row: FactorProductRow) {
    const index = rows.findIndex((x) => x.id === row.id);
    if (index < 0) return;
    rows[index] = { id: shortid.generate() + index + 1 };
    let newRows = [...rows];
    newRows = spreadCost(newRows, state.costs[1]);
    newRows = spreadCost(newRows, state.costs[0]);
    setRows(newRows);
    reRender();
  }

  function getCostPrice(val?: { val: number; cond?: Cond }, price?: number) {
    if (val === undefined || price === undefined) return 0;
    switch (val?.cond?.value) {
      case "percent":
        return price * (val.val / 100);
      default:
        return parseFloat(val.val ? val.val.toString() : "0");
    }
  }

  function getTotalPrice(row: FactorProductRow) {
    const discount = getCostPrice(row.discountInput, row.price);
    const tax = getCostPrice(row.taxInput, (row.price || 0) - discount);
    const price = row.price;
    const count = row.count;
    return ((price || 0) + (tax || 0) - (discount || 0)) * (count || 0);
  }

  function getPrice(product: Product) {
    const plan = state.pricePlan;
    const val = `${plan.value}`;
    let price = 0;
    switch (val) {
      case "sellPrice":
        price = product.sellPrice ? product.sellPrice : 0
        break;
      case "buyPrice":
        price = product.buyPrice ? product.buyPrice : 0
        break;
      default:
        price = product.pricePlanPrice ? product.pricePlanPrice : 0
        break;
    }
    return change(defCur.en_title, state.currency.en_title, price);
  }

  function handleChange(row: FactorProductRow, spreadCosts?: boolean) {
    const index = rows.findIndex((x) => x.id === row.id);
    if (index < 0) return;
    let newRows = [...rows];
    newRows[index] = row;
    if (spreadCosts) {
      newRows = spreadCost(newRows, state.costs[1]);
      newRows = spreadCost(newRows, state.costs[0]);
    }
    setRows(newRows);
    reRender();
  }

  function handleCostsChange({ active, val, cost }: { val: any; active: boolean; cost: Cost }) {
    let value = +val?.val;
    if (value >= prices.tablePrice && cost.key !== "transport") {
      value = prices.tablePrice;
    }
    if (!active) {
      value = 0;
    }
    const type = val?.cond?.value;
    cost.active = active
    const Rows = spreadCost(rows, { ...cost, value, type });
    setRows(Rows);
    setState((x) => ({
      ...x,
      costs: x.costs.map((y) => (y.title === cost.title ? { ...y, value, type, active } : y))
    }));
  }
  function getTaxCond() {
    return [
      { ...conds.tax[0] },
      { ...conds.tax[1], label: <span className="font-bold">{state.currency.en_title}</span> }
    ];
  }

  function spreadCost(rows: FactorProductRow[], cost: Cost) {
    const name = cost.name;
    const cond = taxConditions.find((x) => x.value === cost.type) || taxConditions[0];
    const tablePrice = rows.map((x) => (x.price || 0) * (x.count || 0)).reduce((a, b) => a + b);
    let p = 0;
    let totalDiscount = 0;
    const newRows = rows.map((row, i) => {
      const last = rows.filter((r) => r.productId && r.quantity).length === i + 1;
      let price = 0;
      if (row.price && row.count) {
        price = row.price * row.count;
      }
      let costValue = 0
      if (cost.key === "discount") {
        costValue = !cost.active ? 0 : cost.value > 0 ? cost.value : row.discountInput?.val ? row.discountInput?.val : 0;

      }
      else if (cost.key === "tax") {

        costValue = !cost.active ? 0 : cost.value > 0 ? cost.value : row.taxInput?.val ? row.taxInput?.val : 0;
      } else {
        costValue = cost.active ? cost.value : 0

      }
      if (cost.type === "currency" && tablePrice > 0) {
        costValue = row.quantity ? Math.round((cost.value * (price / tablePrice)) / (row.quantity ?? 1)) : 0;
        if (last) {
          costValue = (cost.value - totalDiscount) / (row.quantity ?? 1);
        } else {
          totalDiscount += row.quantity ? costValue * (row.quantity ?? 1) : 0;
        }
      }
      let nr = { ...row };
      if (name && row.productId) {
        p = p + costValue;
        nr = { ...nr, [name]: { cond, val: active ? costValue : 0 } };
        // if (last) {
        // nr = {...nr, [name]: {cond, val: active ? tablePrice - p : 0}};
        // }
        nr = { ...nr, totalPrice: getTotalPrice(nr) };
      }
      return nr;
    });
    return newRows;
  }

  function handleWarehouseChange(id?: number) {
    setRows((Rows) => Rows.map((row) => (row.productId ? { ...row, warehouseId: id } : row)));
    if (id) {
      setData((x) => ({ ...x, WarehouseId: id }));
      setState((x) => ({
        ...x,
        settings: { ...x.settings, warehouse: { ...x.settings.warehouse, active: true } }
      }));
    }
  }

  async function handleMultiSelect(Rows?: MultiSelectRow[]) {
    if (!Rows) return;
    for (let Row of Rows) {
      let row = rows.find((x) => !x.productId);
      let nRows = undefined;
      if (!row) {
        const a = await handleAddRow();
        row = { id: a.id };
        nRows = a.rows;
      }
      row = { ...row, count: Row.count }
      await addProduct(Row.product, row, nRows);
    }

  }

  /* -------------------------------- Data Structure ------------------------------- */
  const tabs: ContainedTabsProps = {
    tabs: [
      { label: "فروش", activeColor: "#CB0B0B" },
      { label: "خرید", activeColor: "#1E8E1B" },
      { label: "ضایعات", activeColor: "#D07E10" }
    ],
    minWidth: 80,
    size: 2,
    activeTab: active.tab,
    changeViaProps: true,
    onChange: (val) => {
      if (id && type) return
      if (val === undefined) return;
      if (state.transactions.length > 0 || data.PersonId) {
        const action: any = () => {
          setState((x) => ({ ...x, transactions: [] }));
          setData(initialData);
          // setProduct([])
          setActive((x) => ({ ...x, tab: val }));
        };
        dispatch(setConfirm("فرم و لیست تراکنش ها ریست خواهند شد ، آیا مطمئنید؟", action));
      } else {
        setActive((x) => ({ ...x, tab: val }));
      }
    }
  };
  const beforeLoadingPerSelectBox: BasicSelectProps["beforeLoadingPerSelectBox"] = ({ name, params, status }) => {
    switch (name) {
      case "selectProDuct": {
        if (status === "beforeSendRequest") {
          params["type"] = typesOnTabs[active.tab]
          params["pricePlanId"] = state.pricePlan.value
          return params

        } else {
          let products = setSelectItemLabels(params.products, "id", "title");
          products = products.map((x: any) => {
            return {
              ...x,
              ind: x.accountingCode,
              image: x.imageUrl || productImage,
              //@ts-ignore
              dsc: x.barcodes?.join(", "),
              render: (option: any) => productsSelectBoxLayout(option)
            }
          })
          return products
        }
      }
        break;
      case "selectBuyer":
      case "selectSeller":
      case "selectSell":
        if (status === "beforeSendRequest") {
          params["personType"] = "allPerson"
          return params
        } else {
          const persons = setSelectItemLabels(params.persons, "id", "nickName");
          return persons.map((x: any) => ({
            ...x,
            image: x.avatar || avatar,
            dsc: `${x.mobile || ""}`,
            ind: x.accountingCode,
            title: x.nickName
          }))
        }
      default:
        break;
    }
  }
  const GetBalance = () => {
    if (data.PersonId) {
      return dispatch(
        apiGetPersonSettings({ personId: data.PersonId, token }, (res: any) => {
          setData((x) => ({ ...x, personSettings: res.person }));
        })
      );

    }
    dispatch(apiSetAlert(`ابتدا فیلد ${active.tab == 0 ? "خریدار" : "فروشنده"} را وارد نمایید`, "error"))
  }
  const inputs: FormInput[] = [
    {
      id: "buyer",
      name: "PersonId",
      type: "select",
      label: "خریدار",
      required: true,

      className: "flex",
      onChange: (val: number, p) => {
        if (isEdit && val === data.PersonId) return

        const title = `فاکتور فروش ${active.returned ? "برگشتی " : ""}${p?.nickName}`;
        setData((x: any) => ({ ...x, PersonId: val, title }));

      },
      options: [],
      inputProps: {
        defaultValue: data.PersonId ? data.PersonId : DefaultCustomer ? DefaultSelectedPerson : 0,
        withSearch: true,
        closeOnFooterClick: true,
        withRefresh: true,
        name: "selectBuyer",
        searchColumns: "nickName,firstName,accountingCode,lastName,mobile",
        requestInfo: { method: "get", url: "/persons/list/active" },
        beforeLoadingPerSelectBox: beforeLoadingPerSelectBox,
        footer: (
          <BasicButton
            onClick={() => {
              dispatch(
                appSetModal({
                  component: "person",
                  title: "افزودن شخص",
                  closeButton: true,
                  onFinish: (token: any, res: any) => {
                    if (res) {
                      const title = `فاکتور فروش ${active.returned ? "برگشتی " : ""}${res?.nickName}`;
                      setData((x: any) => ({ ...x, PersonId: res.id, title }));

                    }
                  }
                })
              );
            }}
          >
            <PlusIcon scale={0.7} /> <span>افزودن شخص</span>
          </BasicButton>
        ),

        sideSection:
          data.personSettings?.balanceAmount ? (
            <div className="flex flex-col gap-6">
              <div className="flex gap-4">

                <span>تراز:</span>
                {parseInt(data.personSettings.balanceAmount) === 0 ? (
                  <span>0</span>
                ) : parseInt(data.personSettings.balanceAmount) > 0 ? (
                  <span className="text-green-700">بستانکار</span>
                ) : (
                  <span className="text-red-700">بدهکار</span>
                )}
              </div>
              <div className="flex gap-4">
                <span className="text-sm text-[#8D8E8F]">{getCurrency().defCur.en_title}</span>
                <span className="text-sm" style={{ direction: "ltr" }}>
                  {Intl.NumberFormat().format(Math.abs(parseInt(data.personSettings.balanceAmount)))}
                </span>
              </div>
            </div>
          ) : (<div className="flex flex-col gap-6 text-nowrap  border p-2 border-gray-300 rounded-md text-gray-500">

            <span className="cursor-pointer" onClick={GetBalance}>مشاهده تراز</span>
          </div>),
        menuStyle: { minWidth: isMobile ? 360 : 380 }
      }
    },
    {
      id: "seller",
      name: "PersonId",
      type: "select",
      label: "فروشنده",
      defaultValue: data.PersonId ? data.PersonId : 0,
      withRefresh: true,
      className: "flex",
      required: true,
      onChange: (val: number, p) => {
        // dispatch(
        //   apiGetPersonSettings({ personId: val, token }, (res: any) => {
        //     setData((x) => ({ ...x, personSettings: res.person }));
        //   })
        // );
        if (isEdit && val === data.PersonId) return

        const title = `فاکتور خرید ${active.returned ? "برگشتی " : ""}${p?.nickName}`;
        setData((x: any) => ({ ...x, PersonId: val, title }));
        // if (isEdit ? data.PersonId : personInfo.selectSeller ? personInfo.selectSeller : data.PersonId !== val) {

        //   setPersonInfo(state => { return { ...state, selectSeller: 0 } })
        //   setData((x: any) => ({
        //     ...x,
        //     PersonId: val,
        //     title: `فاکتور خرید ${active.returned ? "برگشتی " : ""}${p.nickName}`
        //   }));
        // }
      },
      options: [],
      inputProps: {
        withSearch: true,
        closeOnFooterClick: true,
        withRefresh: true,
        name: "selectSeller",
        searchColumns: "nickName,firstName,accountingCode,lastName,mobile",
        requestInfo: { method: "get", url: "/persons/list/active" },
        beforeLoadingPerSelectBox: beforeLoadingPerSelectBox,

        //  refreshList: () => { if (!persons.length) dispatch(apiPersonsList(token, "allPerson")) },
        footer: (
          <BasicButton
            onClick={() => {
              dispatch(
                appSetModal({
                  component: "person",
                  title: "افزودن شخص",
                  closeButton: true,
                  onFinish: (token: any, res: any) => {
                    if (res) {
                      // dispatch(
                      //   apiPersonsList(token, "allPerson", () => {
                      //   })
                      // );
                      const input = inputs.find((x) => x.id === "buyer");
                      input && input.onChange && input.onChange(res.id, res);
                    }
                  }
                })
              );
            }}
          >
            <PlusIcon scale={0.7} /> <span>افزودن شخص</span>
          </BasicButton>
        ),
        sideSection: data.personSettings?.balanceAmount && (
          <div className="flex flex-col gap-6">
            <div className="flex gap-4">
              <span>تراز:</span>
              {parseInt(data.personSettings.balanceAmount) > 0 ? (
                <span className="text-green-700">بستانکار</span>
              ) : (
                <span className="text-red-700">بدهکار</span>
              )}
            </div>
            <div className="flex gap-4">
              <span className="text-sm text-[#8D8E8F]">{getCurrency().defCur.en_title}</span>
              <span className="text-sm" style={{ direction: "ltr" }}>
                {Intl.NumberFormat().format(parseInt(data.personSettings.balanceAmount))}
              </span>
            </div>
          </div>
        ),
        defaultValue: data?.PersonId,
        menuStyle: { minWidth: isMobile ? 360 : 380 }
      }
    },
    {
      id: "dates",
      name: "dates",
      type: "inline",
      required: true,
      className: "flex justify-end",
      inputs: [
        {
          name: "date",
          type: "date",
          label: "تاریخ",
          required: true,
          onChange: (val) => setData((x: any) => ({ ...x, date: val && val[0] })),
          inputProps: {
            defaultValues: data?.date ? [data?.date] : undefined,
            withoutClear: true
          }
        },
        {
          name: "dueDate",
          type: "date",
          label: "تاریخ سررسید",
          onChange: (val) => setData((x: any) => ({ ...x, dueDate: val && val[0] })),
          inputProps: {
            defaultValues: data?.dueDate ? [data?.dueDate] : undefined,
            withoutClear: true
          }
        }
      ]
    },
    {
      id: "date",
      name: "date",
      type: "date",
      label: "تاریخ",
      required: true,
      className: "flex justify-end",
      onChange: (val) => setData((x: any) => ({ ...x, date: val && val[0] })),
      inputProps: {
        defaultValues: data?.date ? [data?.date] : undefined,
        withoutClear: true
      }
    },
    {
      id: "title",
      name: "title",
      type: "text",
      label: "عنوان فاکتور",
      className: "flex",
      required: true,
      onChange: (val) => setData((x: any) => ({ ...x, title: val })),
      inputProps: {
        val: data?.title
      }
    },
    {
      id: "aCode",
      name: "accountingCode",
      type: "text-switchable",
      label: "کد حسابداری",
      className: "flex justify-end",
      required: true,
      onChange: (val) => setData((x: any) => ({ ...x, accountingCode: !!val ? val : undefined })),
      inputProps: {
        val: data?.accountingCode
      }
    },
    {
      id: "taxSettlementType",
      name: "taxSettlementType",
      type: "select",
      label: "نوع تسویه (مودیان)",
      className: "flex justify-end",
      required: false,
      onChange: (val) => {
        setData((x: any) => ({ ...x, taxSettlementType: !!val ? val : undefined }));
      },
      options: [
        {
          dsc: "",
          ind: 0,
          value: 0,
          title: "",
          label: ""
        },
        {
          dsc: "",
          ind: 1,
          value: "Cash",
          title: "نقدی",
          label: "نقدی"
        },
        {
          dsc: "",
          ind: 2,
          value: "Credit",
          title: "نسیه",
          label: "نسیه"
        },
        {
          dsc: "",
          ind: 3,
          value: "CashCredit",
          title: "نقدی/نسیه",
          label: "نقدی/نسیه"
        }
      ],
      inputProps: {
        val: data?.taxSettlementType,
        withClear: true,
        defaultValue: data?.taxSettlementType
      }
    },
    {
      id: "taxType",
      name: "taxType",
      type: "select",
      label: "نوع صورتحساب (مودیان)",
      className: "flex justify-end",
      required: false,
      onChange: (val) => {
        setData((x: any) => ({ ...x, taxType: !!val ? val : undefined }));
      },
      options: [
        {
          dsc: "",
          ind: 0,
          value: 0,
          title: "",
          label: ""
        },
        {
          dsc: "",
          ind: 1,
          value: 1,
          title: "نوع اول",
          label: "نوع اول"
        },
        {
          dsc: "",
          ind: 2,
          value: 2,
          title: "نوع دوم",
          label: "نوع دوم"
        }
      ],
      inputProps: {
        val: data?.taxType,
        withClear: true,
        defaultValue: data?.taxType
      }
    },
    {
      id: "pb",
      name: "pb",
      type: "inline",
      className: "flex",
      inputs: [
        {
          name: "ProjectId",
          type: "select",
          label: "پروژه",
          onChange: (val) => setData((x: any) => ({ ...x, ProjectId: val })),
          options: projects.map((x) => ({
            ...x,
            image: projectAccounting,
            ind: x.accountingCode,
            title: x.title
          })),
          inputProps: {
            closeOnFooterClick: true,
            withSearch: true,
            withRefresh: true,
            withClear: true,
            refreshList: () => dispatch(apiGetProjects(token)),
            footer: (
              <BasicButton
                onClick={() => {
                  dispatch(
                    appSetModal({
                      component: "project",
                      title: "افزودن پروژه",
                      closeButton: true,
                      onFinish: (token: any, res: any) => {
                        if (res) {
                          dispatch(
                            apiGetProjects(token, () => {
                              const input = inputs.find((x) => x.id === "pb")?.inputs;
                              input && input[0].onChange && input[0].onChange(res.id, res);
                            })
                          );
                        }
                      }
                    })
                  );
                }}
              >
                <PlusIcon scale={0.7} /> <span>افزودن پروژه</span>
              </BasicButton>
            ),
            defaultValue: data?.ProjectId,
            preferences: {
              size: 2
            },
            menuStyle: { minWidth: isMobile ? 360 : 380 },
            containerStyle: { width: "100%" }
          }
        },
        {
          name: "BranchId",
          type: "select",
          label: "شعبه",
          onChange: (val) => setData((x: any) => ({ ...x, BranchId: val })),
          options: branches.map((x) => ({
            ...x,
            image: branchAccounting,
            ind: x.accountingCode,
            title: x.title
          })),
          inputProps: {
            closeOnFooterClick: true,
            withSearch: true,
            withRefresh: true,
            withClear: true,

            refreshList: () => dispatch(apiGetBranches(token)),
            footer: (
              <BasicButton
                onClick={() => {
                  dispatch(
                    appSetModal({
                      component: "branch",
                      title: "افزودن شعبه",
                      closeButton: true,
                      onFinish: (token: any, res: any) => {
                        if (res) {
                          dispatch(
                            apiGetBranches(token, () => {
                              const input = inputs.find((x) => x.id === "pb")?.inputs;
                              input && input[1].onChange && input[1].onChange(res.id, res);
                            })
                          );
                        }
                      }
                    })
                  );
                }}
              >
                <PlusIcon scale={0.7} /> <span>افزودن شعبه</span>
              </BasicButton>
            ),
            defaultValue: data?.BranchId,
            preferences: {
              size: 2
            },
            menuStyle: { minWidth: isMobile ? 360 : 380 },
            containerStyle: { width: "100%" }
          }
        }
      ]
    },
    {
      id: "reference",
      name: "reference",
      type: "text",
      label: "ارجاع",
      className: "flex justify-end",
      onChange: (val) => setData((x: any) => ({ ...x, reference: val })),
      inputProps: {
        val: data?.reference
      }
    },
    {
      id: "sell",
      name: "sell",
      type: "inline",
      className: "flex",
      inputs: [
        {
          name: "SellerId",
          type: "select",
          label: "فروشنده",
          withRefresh: true,
          onChange: (val) => {
            //if (data.SellerId !== val)
            setData((x: any) => ({ ...x, SellerId: val }));
            dispatch(
              apiGetPersonSettings({ personId: val, token }, (res: any) => {
                if (res?.person?.saleCommission) {
                  const sc = parseInt(res.person.saleCommission);
                  const SCinput = { val: sc, cond: taxConditions[0] };
                  setData((x: any) => ({ ...x, sellerCommission: sc, commissionType: SCinput.cond.value, SCinput }));
                }
              })
            );
          },
          options: [],

          inputProps: {
            withSearch: true,
            defaultValue: data?.SellerId ? data?.SellerId : 0,
            name: "selectSell",
            searchColumns: "nickName,firstName,accountingCode,lastName,mobile",
            requestInfo: { method: "get", url: "/persons/list/active" },
            beforeLoadingPerSelectBox: beforeLoadingPerSelectBox,
            preferences: {
              size: 2
            },
            closeOnFooterClick: true,
            menuStyle: { minWidth: isMobile ? 360 : 380 },
            containerStyle: { width: "100%" },
            withRefresh: true,

            ///  refreshList: () => { if (!persons.length) dispatch(apiPersonsList(token, "allPerson")) },
            footer: (
              <BasicButton
                onClick={() => {
                  dispatch(
                    appSetModal({
                      component: "person",
                      title: "افزودن شخص",
                      closeButton: true,
                      onFinish: (token: any, res: any) => {
                        if (res) {
                          // dispatch(
                          //   apiPersonsList(token, "allPerson", () => {
                          //   })
                          // );
                          const input = inputs.find((x) => x.id === "sell")?.inputs;
                          input && input[0].onChange && input[0].onChange(res.id, res);
                        }
                      }
                    })
                  );
                }}
              >
                <PlusIcon scale={0.7} /> <span>افزودن شخص</span>
              </BasicButton>
            )
          }
        },
        {
          name: "sellerCommission",
          type: "cond",
          label: "پورسانت",
          onchange: (val) => {
            const sellerCommission = val.val;
            let commissionType = val.cond.value;
            setData((x: any) => ({ ...x, commissionType, sellerCommission, SCinput: val }));
          },
          conditions: taxConditions,
          val: data.SCinput?.val,
          cond: data.SCinput?.cond
        }
      ]
    }
  ];

  // Table
  let indexesToHide = [
    ...state.costs.filter((x) => x.key && !x.active).map((x) => x.key),
    ...Object.keys(state.settings).filter((x) => !(state.settings as any)[x].active)
  ];

  const table: TableProps = {
    headers: [
      { key: "product", label: "کالا", style: { width: 260 } },
      { key: "totalCount", label: "موجودی کل", style: { width: 80 } },
      { key: "warehouse", label: "انبار", style: { width: 150 } },
      { key: "description", label: "شرح", style: { minWidth: 200 } },
      { key: "unit", label: "مقدار / واحد", style: { width: 130 } },
      { key: "price", label: "مبلغ واحد", style: { width: 160 } },
      { key: "discount", label: "تخفیف", style: { width: 130 } },
      { key: "tax", label: "مالیات", style: { width: 130 } },
      { key: "totalPrice", label: "مبلغ کل", style: { width: 150 } }
    ].filter((x) => !indexesToHide.includes(x.key)),
    cols: [
      {
        Comp: Select,
        key: "product",
        data: {
          options: []

        },
        options: {
          inputProps: {
            withClear: true,
            withRefresh: true,
            name: "selectProDuct",
            searchColumns: "title,code,accountingCode,id",
            requestInfo: { method: "get", url: "/products/list/active" },
            beforeLoadingPerSelectBox: beforeLoadingPerSelectBox,


            // refreshList: (args: { index: number, callBackIfDataFinish: Function }) => {
            //   const { callBackIfDataFinish, index } = args
            //   return dispatch(apiProductsListByPageNumber({
            //     token, page: index, type: typesOnTabs[active.tab], pricePlanId: state.pricePlan.value,
            //     cb: (res: any) => {
            //       
            //       if (res.length === 0) {
            //         return callBackIfDataFinish()
            //       }
            //       setProduct(state => [...state, ...res])
            //     }
            //   }))}

            preferences: { size: 3 },
            closeOnFooterClick: true,
            menuStyle: { minWidth: isMobile ? 360 : 420 },
            btnTextStyle: { fontSize: 12 },
            containerStyle: { minWidth: 260, maxWidth: 400 },
            btnStyle: { minWidth: 0 },
            footer: (
              <BasicButton
                onClick={() => {
                  dispatch(
                    appSetModal({
                      component: "product",
                      title: "افزودن محصول",
                      closeButton: true,
                      onFinish: (token: any, res: any) => {
                        if (res) {
                          dispatch(apiProductsList({
                            type: typesOnTabs[active.tab], token, cb: async (ress: any) => {
                              // setProduct(ress)
                              await new Promise((resolve) => setTimeout(resolve, 200));

                              const input = table.cols.find((x) => x.key === "product");
                              input &&
                                input?.options?.onChange &&
                                input.options.onChange(res, { row: state.curRow });
                            }
                          }))
                        }
                      }
                    })
                  );
                }}
              >
                <PlusIcon scale={0.7} /> <span>افزودن محصول</span>
              </BasicButton>
            )
          },
          onClear: (row: FactorProductRow) => clearProduct(row),
          onChange: (val: any, { row }: any) => {
            addProduct(val, row)

          }
        },
        getValue: (item: any) => item.productId
      },
      {
        Comp: Text,
        key: "totalCount",
        options: {
          type: "price",
          emptyOnNoVal: true,
          editable: false,
          changeOnBlur: false,
          deps: ["productId"],
          style: { minWidth: 80, },
          inputProps: { style: { direction: "ltr" }, classes: "&>input:[-webkit-text-fill-color:red]" },
        },


      },
      {
        Comp: Select,
        key: "warehouse",
        data: {
          options: warehouseStock
        },
        options: {
          inputProps: {
            preferences: { size: 3 },
            menuStyle: { minWidth: isMobile ? 360 : 380 },
            btnTextStyle: { fontSize: 12 },
            containerStyle: { width: 150 },
            btnStyle: { minWidth: 0 },
            withClear: true,
            withRefresh: true,
            noDefOption: true,
            refreshList: () => {
              if (state.curRow?.productId) {
                getInventoryProductCount(state.curRow?.productId, true)
              } else {
                setWarehouseStock([])
              }
            },
          },
          /// deps: ["productId"],
          onChange: (val: any, { row }: any) => {
            let nr = { ...row, warehouseId: val.id };
            handleChange(nr);
          },
          onClear: (row: any) => {
            let nr = { ...row, warehouseId: undefined };
            handleChange(nr);
          },
          placeholder: "",
          dependentData: true,
          depKey: "product",
          normalizeFunction: (data: any) => {
            return warehouseStock
            // if (!warehouseStock) return;
            // if (!warehouseStock[data.id]) {
            //   return warehouses.map((x) => ({
            //     ...x,
            //     ind: x.accountingCode,
            //     image: projectAccounting,
            //     dsc: x.address,
            //     render: renderWarehouse
            //   }));
            // }

            // const warehouseSupplies = warehouseStock[data.id].supply.reduce(
            //   //@ts-ignore
            //   (a, v) => ({ ...a, [v.warehouseId]: v }),
            //   {}
            // );
            // return warehouses.map((x) => ({
            //   ...x,
            //   ind: x.accountingCode,
            //   image: projectAccounting,
            //   dsc: x.address,
            //   supply: warehouseSupplies[x.id],
            //   render: renderWarehouse
            //   //we can add onChange here
            // }));
          }
        },
        getValue: (item: any) => item.warehouseId
      },
      {
        Comp: Text,
        key: "description",
        options: {
          emptyOnNoVal: true,
          editable: true,
          changeOnBlur: false,
          deps: ["productId"],
          style: { minWidth: 190 },
          onChange: (val: any) => handleChange(val)
        },
        getValue: (item: any) => item.description
      },
      {
        Comp: CondInput,
        key: "unit",
        options: {
          emptyOnNoVal: true,
          editable: true,
          conditionsKey: "unitConds",
          deps: ["productId"],
          onChange: (val: any, p: any) => {
            const { row } = p;
            const rate = row.conversionRatio;
            const quantity = parseFloat(val?.val || "0");
            const unit = val?.cond?.title;
            const index = row?.unitConds.findIndex((x: any) => x.title === unit);
            let count = quantity;
            let price = row?.constantPrice;
            if (index === 1) {
              price = (price || 0) * rate;
            }
            let nr = { ...row, quantity, unit, count, price, constantPrice: row?.constantPrice };
            nr = { ...nr, totalPrice: getTotalPrice(nr) };
            handleChange(nr, true);
          },
          style: { width: 120 }
        },
        getValue: (item: any) => {
          if (item.quantity === undefined || !item.unit || !item.unitConds) return undefined;
          return { val: `${item.quantity}`, cond: item.unitConds.find((x: any) => x.title === item.unit) };
        }
      },
      {
        Comp: Price,
        key: "price",
        options: {
          editable: true,
          emptyOnNoVal: true,
          currency: state.currency.en_title,
          deps: ["productId"],
          changeOnBlur: false,
          inputProps: { style: { minWidth: 150, maxWidth: 150 } },
          onChange: (val: any, { row }: any) => {
            let nr = { ...row, price: val?.price, constantPrice: val?.price };
            nr = { ...nr, totalPrice: getTotalPrice(nr) };
            handleChange(nr);
          }
        }
      },
      {
        Comp: CondInput,
        key: "discount",
        options: {
          emptyOnNoVal: true,
          editable: true,
          conditions: taxConditions,
          style: { minWidth: 120 },
          deps: ["productId", "totalDiscount"],
          onChange: (val: CondInputProps["val"], { row }: any) => {
            let nr = { ...row, discountInput: val };
            nr = { ...nr, totalPrice: getTotalPrice(nr) };
            handleChange(nr);
          }
        },
        getValue: (item: any) => item?.discountInput
      },
      {
        Comp: CondInput,
        key: "tax",
        options: {
          emptyOnNoVal: true,
          editable: true,
          conditions: taxConditions,
          style: { minWidth: 120 },
          deps: ["productId", "totalTax"],
          onChange: (val: CondInputProps["val"], { row }: any) => {
            let nr = { ...row, taxInput: val };
            nr = { ...nr, totalPrice: getTotalPrice(nr) };
            handleChange(nr);
          }
        },
        getValue: (item: any) => item?.taxInput
      },
      {
        Comp: Price,
        key: "totalPrice",
        style: { padding: 0 },
        options: {
          emptyOnNoVal: true,
          emptyOnNoValNoBorder: true,
          currency: state.currency.en_title,
          classes: "bg-slate-100 rounded-md h-10 py-2 px-4 mx-2",
          deps: ["totalPrice"]
        }
      }
    ].filter((x) => !indexesToHide.includes(x.key)),
    mobileLayout: MobileRow,
    rows,
    headerColor: "#fff",
    bgColor: "#fff",
    withBorder: true,
    tableBorder: false,
    tableStyles: { width: "100%" },
    pagination: {
      ...state.pagination,
      onChange: ({ page, perPage }) =>
        setState((x: any) => ({ ...x, pagination: { ...x.pagination, page, perPage } }))
    },
    onDelete: (row) => {

      const newRows = rows.filter(r => r.id !== row.id);
      setRows(newRows);
    },
    onAddRow: handleAddRow,
    handleRowClick: (row: any) => setState((x) => ({ ...x, curRow: row })),
    paginationAction: <MultiSelect onChange={handleMultiSelect} activeTab={typesOnTabs[active.tab]} />
  };

  return {
    setActive,
    setState,
    reRender,
    handleCostsChange,
    handleAddRow,
    handleSubmit,
    handleBarcodeScan,
    handleWarehouseChange,
    handleMultiSelect,
    setData,
    navigate,
    dispatch,
    store,
    tabs,
    rows,
    persons,
    warehouses,
    inputs,
    table,
    pricePlans,
    currencies,
    active,
    state,
    data,
    person,
    project,
    branch,
    seller,
    taxConditions,
    unitConditions,
    inputsOnTabs,
    isEdit,
    indexesToHide,
    saved,
    isMobile,
    type: typesOnTabs[active.tab],
    sellerCommission: getCostPrice(data.SCinput, prices.profitPrice),
    DisableTax,
    factor,
    ...prices
  };
}
